<template>
  <div class="feedbacks-page pa-6">
    <p-container>
      <!-- Title -->
      <h2 class="mb-4">
        {{ $t('page.dashboard.admin.feedbacks.title') }}
      </h2>
      <p-row>
        <!-- Search Field -->
        <p-col xs12 md6 lg3>
          <p-text-field v-model="page.adminFeedbacksDataSource.filter.searchCriteria" clearable :label="$t('core.app.search')" context-icon="search"></p-text-field>
        </p-col>
        <!-- Organisation Filter -->
        <p-col xs12 md6 lg3>
          <p-select
            v-model="page.organisationsDataSource.filter.selectedOrganisationId"
            clearable
            :label="$t('page.companies.select.organisationName')"
            :items="page.organisationNameItems"
            @input="page.refreshFeedbacks()"
          ></p-select>
        </p-col>
        <!-- Event Filter -->
        <p-col xs12 md6 lg3>
          <p-select
            v-model="page.eventsDataSource.filter.eventIdentifier"
            :label="$t('page.events.select.eventName')"
            :items="page.eventItems"
            @input="page.refreshFeedbacks()"
          ></p-select>
        </p-col>
      </p-row>
      <p-list-view
        v-model="page.adminFeedbacksList"
        :pagination.sync="page.adminFeedbacksDataSource.paging"
        :columns="page.feedbackColumns"
      >
        <template slot="table-actions">
          <!-- Refresh Button -->
          <p-button :disabled="isLoading" @click="page.refreshFeedbacks()">
            <p-icon>refresh</p-icon>
          </p-button>
          <!-- Excel ausdruck Button -->
          <div v-if="page.adminFeedbacksDataSource.data">
            <p-button v-if="page.adminFeedbacksDataSource.data.items.length > 0" :disabled="isLoading" :loading="page.isLoadingExcel" @click="page.downloadExcel()">
              {{ $t('page.dashboard.adminFeedbacks.button.excelDownload') }}
            </p-button>
          </div>
        </template>
      </p-list-view>
    </p-container>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import FeedbacksPage from './feedbacks.vue.model';

  export default Vue.extend({
    name: 'Feedbacks',
    data: () => ({
      page: new FeedbacksPage(),
      isLoading: false,
    }),
    computed: {
      isAdmin(): boolean {
        let isAdmin = false;
        if (this.$auth.isLoggedIn) {
          isAdmin = this.$auth.isInRole('Admin', 'HostAdmin');
        }
        return isAdmin;
      },
    },
    async beforeMount() {
      this.isLoading = true;
      if (await this.$service.v2.api.tdg_Users.amIOrganisation()) {
        await this.$router.push('/tourdegwaerb/organisation/dashboard');
      } else if (await this.$service.v2.api.tdg_Users.amICompany()) {
        this.$router.push('/tourdegwaerb/company/dashboard');
      } else if (this.isAdmin) {
        try {
          await this.page.initialize();
        } catch (error) {
          this.$log.error('Failed to load organisations:');
        }
        this.isLoading = false;
      } else {
        this.$auth.redirectToLogin();
      }
    },
  });
</script>
